import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X } from 'lucide-react';

// Replaced backend-based constants with local static values
const LOGO_URL = "/images/mehartraderslogo.jpeg"; // put logo file in public/assets/logo.png
const ACCENT_BG = "bg-teal-600";     // same accent tone used in your UI
// PRIMARY_COLOR not needed here since it's not used directly

// const TEXT_COLOR = 'text-gray-100';

const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Shop', path: '/shop' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
];

export const Header = ({ totalCartItems }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <header className="fixed top-0 left-0 right-0 bg-gray-900 border-b border-teal-700 shadow-2xl z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">

                {/* Logo */}
                <Link to="/" className="flex items-center">
                    <img
                        src={LOGO_URL}
                        alt="Mehar Traders Logo"
                        className="h-14 sm:h-16 w-16 sm:w-20 rounded-lg object-cover border-2 border-teal-500"
                    />
                </Link>

                {/* Desktop Navigation & Cart */}
                <nav className="hidden md:flex items-center space-x-3 lg:space-x-5">
                    {navItems.map(item => (
                        <Link
                            key={item.name}
                            to={item.path}
                            className={`px-3 py-2 rounded-lg font-medium text-gray-100 hover:text-teal-400 transition-colors`}
                        >
                            {item.name}
                        </Link>
                    ))}

                    <button
                        onClick={() => navigate("/cart")}
                        className={`${ACCENT_BG} text-white px-5 py-2.5 rounded-full flex items-center relative shadow-lg hover:scale-105 transition-transform`}
                        aria-label="Go to cart"
                    >
                        <ShoppingCart className="w-5 h-5 mr-2" />
                        Cart
                        {totalCartItems > 0 && (
                            <span className="absolute top-0 right-0 transform translate-x-1/4 -translate-y-1/4 bg-red-600 text-white text-xs sm:text-sm font-bold px-2 py-0.5 rounded-full ring-2 ring-gray-900">
                                {totalCartItems}
                            </span>
                        )}
                    </button>
                </nav>

                {/* Mobile Menu & Cart */}
                <div className="flex items-center md:hidden">
                    <button
                        onClick={() => navigate("/cart")}
                        className="relative mr-4 p-2 rounded-full text-gray-100 hover:bg-gray-800"
                        aria-label="Go to cart"
                    >
                        <ShoppingCart className="w-6 h-6" />
                        {totalCartItems > 0 && (
                            <span className="absolute top-0 right-0 transform translate-x-1/4 -translate-y-1/4 bg-red-600 text-white text-xs font-bold w-4 h-4 flex items-center justify-center rounded-full ring-2 ring-gray-900">
                                {totalCartItems}
                            </span>
                        )}
                    </button>

                    <button
                        className="p-2 rounded-lg text-gray-100 hover:bg-gray-800 transition-colors"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        aria-label="Toggle menu"
                    >
                        {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            <div
                className={`md:hidden bg-gray-900 absolute w-full top-full border-t border-gray-800 py-4 shadow-xl transition-all duration-300 ${
                    isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                }`}
            >
                <nav className="flex flex-col items-center space-y-3">
                    {navItems.map(item => (
                        <Link
                            key={item.name}
                            to={item.path}
                            className="w-full text-center text-gray-100 hover:text-teal-400 py-2 font-medium border-b border-gray-800"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            {item.name}
                        </Link>
                    ))}
                </nav>
            </div>
        </header>
    );
};

export default Header;
